import deliveryManifestCombinedComponent from './delivery_manifest_combined.component';

let deliveryManifestCombinedModule = angular.module('deliveryManifestCombined', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/routeControl')

        $stateProvider.state('deliveryManifestCombined', {
            url: '/delivery-manifest-combined',
            component: 'deliveryManifestCombined',
            data: {
                requireLogin: true,
                requireACL: 'route_control.all'
            },
        })

    })

    .component("deliveryManifestCombined", deliveryManifestCombinedComponent)

    .name;

export default deliveryManifestCombinedModule;


// WEBPACK FOOTER //
// ./client/app/components/route_control/delivery_manifest_combined/index.js